import { createContext } from 'react';

export const FormTabsContext = createContext<{ activeKey: string }>({
  activeKey: '',
});
